import React from "react";

function RetryIcon() {
    return (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#as3sssngla)">
                <path
                    d="m4.216 3.587.488.341a.25.25 0 0 1-.065.443l-1.694.558a.25.25 0 0 1-.328-.23L2.568 2.92a.25.25 0 0 1 .393-.212l.404.283A4 4 0 1 1 2 6h1a3 3 0 1 0 1.216-2.414z"
                    fill="#637590"
                />
            </g>
            <defs>
                <clipPath id="as3sssngla">
                    <path fill="#fff" d="M0 0h12v12H0z" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default RetryIcon;
